export default __webpack_public_path__ + "static/media/chemistryIcon.3f8ebee8.svg";